/**
 * @generated SignedSource<<ab13cbfdc13658b1f650ee94d5df9bfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Comments_GetShortURLMutation$variables = {
  threadId: string;
};
export type Comments_GetShortURLMutation$data = {
  readonly Comment_GetShortURL: {
    readonly url: string;
  } | null;
};
export type Comments_GetShortURLMutation = {
  response: Comments_GetShortURLMutation$data;
  variables: Comments_GetShortURLMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "threadId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "threadId",
        "variableName": "threadId"
      }
    ],
    "concreteType": "GetShortUrl",
    "kind": "LinkedField",
    "name": "Comment_GetShortURL",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Comments_GetShortURLMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Comments_GetShortURLMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "21d40390a1b113fbc92ef491de0c480e",
    "id": null,
    "metadata": {},
    "name": "Comments_GetShortURLMutation",
    "operationKind": "mutation",
    "text": "mutation Comments_GetShortURLMutation(\n  $threadId: ID!\n) {\n  Comment_GetShortURL(threadId: $threadId) {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "82138ec796ec1ae282b5671edae28931";

export default node;
